import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CurrentUserBootstrapService } from '../current-user-bootstrap.service';
import { CurrentUserStore } from '../current-user.store';
import { redirectForBlockedSession } from './session-guard-redirects';

export const onboardingRequiredGuard: CanActivateFn = async (_route, state) => {
  const bootstrap = inject(CurrentUserBootstrapService);
  const router = inject(Router);
  const store = inject(CurrentUserStore);
  const result = await bootstrap.ensureSession();

  if (result.status === 'onboarding-required' && store.requiresDeveloperOnboarding()) {
    return true;
  }

  if (result.status === 'active') {
    return router.parseUrl(store.resolveDefaultRedirectUrl());
  }

  return redirectForBlockedSession(result, router, store, state.url);
};
